import React, { useEffect } from 'react';
import styled from 'styled-components';
import WarningOutlined from '@ant-design/icons/lib/icons/WarningOutlined';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import { AuthorAdditionalInfo } from '../api/Author';

export const Error = ({ message }: { message: string }) => (
    <ErrorGrid>
        <WarningOutlined />
        {message}
    </ErrorGrid>
);

const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: ${({ theme }) => `${theme.spacing.xs}`};
    align-items: center;
`;

const ErrorGrid = styled(TwoColumnGrid)`
    color: ${({ theme }) => theme.palette.text.error.hex};
`;

const ScrollToTopOnPageChangeImpl = ({ history }: RouteComponentProps) => {
    useEffect(() =>
        history.listen(() => {
            window.scrollTo(0, 0);
        })
    );
    return null;
};

export const ScrollToTopOnPageChange = withRouter(ScrollToTopOnPageChangeImpl);

export const getDisplayName = (
    authorInfo: AuthorAdditionalInfo,
    hasMultiplePersonas?: boolean
): string => {
    if (authorInfo.personaIdx) {
        const p = Number(authorInfo.personaIdx);
        return `${authorInfo.name} -- Persona ${p + 1}`;
    } else {
        return `${authorInfo.name}${hasMultiplePersonas ? ' -- Overall (default)' : ''}`;
    }
};

export const TryExamples = ({
    examples,
    queryUrl,
    className,
}: {
    examples: Array<{ label: string; queryString: string }>;
    queryUrl: string;
    className?: string;
}) => (
    <TrySuggestions className={className}>
        <strong>Try:</strong>{' '}
        {examples
            .map<React.ReactNode>((ex) => (
                <Link key={ex.label} to={`${queryUrl}${ex.queryString}`}>
                    {ex.label}
                </Link>
            ))
            .reduce((prev, curr) => [prev, `, `, curr])}
    </TrySuggestions>
);

const TrySuggestions = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    strong {
        font-weight: 400;
        margin-right: ${({ theme }) => theme.spacing.xxs};
    }
    a {
        margin-left: ${({ theme }) => theme.spacing.xxs};
    }
`;
